// extracted by mini-css-extract-plugin
var _1 = "UserInvitationFormModal-modulebox__Qm4g4";
export { _1 as "box" }
